export default "__VITE_ASSET__DBAfElrA__"